import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Estructura de entrega',
  subtitle: 'Elija cómo se entregan los pedidos (por ubicación).',
  form: {
    delivery_mode: {
      label: 'Modo de entrega',
      placeholder: 'Seleccionar modo de entrega',
      options: {
        [DeliveryMode.Internal]: 'Interno (conductores propios)',
        [DeliveryMode.External]: 'Externo (terceros)',
      },
    },
  },
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
    skip: 'Omitir',
  },
  toasts: {
    error: 'Algo salió mal. Inténtelo de nuevo.',
  },
};
